import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';
import { Vraag } from '../claims/vraag';
import { Antwoord } from '../claims/antwoord';
import { VraagboomSelectieResultaat } from '@models/vragenboom';

export class VraagboomAntwoord<TResultaat extends IBaseVraagboomResultaat> {
  vraag: Vraag;
  antwoorden: Antwoord[];
  resultaat: TResultaat;
  isValid: boolean;
  antwoordVerbergen: boolean;

  public calculateNextVraagId(resultaten: VraagboomAntwoord<IBaseVraagboomResultaat>[]): string {
    const conditions = this.vraag.conditions ?? [];
    for (const condition of conditions) {
      if (!condition.antwoorden)
        return condition.linkt_naar;

      if (condition.antwoorden.length === 1
        && this.vraag.antwoorden?.length === 1 && this.vraag.antwoorden[0].variabeleWaarden) {
        // controleer of een van de variabelewaarden in de conditie staat
        const indexAnswer = condition.antwoorden[0].antwoordId.lastIndexOf('=');
        const selectieResult = this.resultaat as unknown as VraagboomSelectieResultaat;
        if (indexAnswer > 0 && selectieResult !== null
          && this.antwoorden?.length === 1 && this.antwoorden[0].variabeleWaarden) {
          const indexVar = this.antwoorden[0].variabeleWaarden.find(v => v === condition.antwoorden[0].antwoordId.substring(0, indexAnswer));
          if (indexVar !== null && selectieResult.code === condition.antwoorden[0].antwoordId.substring(indexAnswer + 1)) {
            return condition.linkt_naar;
          }
        }
      }

      const allAnswersMatch = condition.antwoorden.every(ca => {
        const antwoorden = this.vraag.id === ca.vraagId ? this.antwoorden : resultaten.find(a => a.vraag.id === ca.vraagId)?.antwoorden;
        return antwoorden?.findIndex(antwoord => antwoord.id === ca.antwoordId) >= 0 ?? false;
      });

      if (allAnswersMatch)
        return condition.linkt_naar;
    }

    if (this.antwoorden?.length > 0) {
      return this.antwoorden[0].linkt_naar;
    } else if (this.vraag?.antwoorden?.length > 0) {
      return this.vraag.antwoorden[0].linkt_naar;
    }

    return null;
  }
}
